import classNames from 'classnames';
import React from 'react';
import Button from './Button';
import Caret from './Caret';
import * as styles from './CaretButton.module.scss';

const CaretButton = React.forwardRef<
  HTMLButtonElement,
  React.ComponentProps<typeof Button>
>(({ children, disabled, active, className, ...rest }, ref) => {
  if (disabled) {
    return <span className={styles.label}>{children}</span>;
  }

  return (
    <Button
      ref={ref}
      className={classNames(styles.button, className, {
        [styles.isActive]: active,
      })}
      {...rest}
    >
      <span className={styles.label}>{children}</span>
      <Caret />
    </Button>
  );
});

export default CaretButton;
